import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LocalDateTime } from "@js-joda/core";
import dropOffLocationQueryKeys from "@modules/drop-off-location/dropOffLocationQueryKeys";
import tradeInQueryKeys from "@modules/trade/types/tradeInQueryKeys";

type Request = {
  appointmentAt: LocalDateTime;
  dropOffLocationId: string;
  source: string;
  tradeInToken: string;
};

type ResponseBody = {
  isAppointmentUnavailable: boolean;
};

const putScheduleGuestBuyInAppointment = async ({
  appointmentAt,
  dropOffLocationId,
  source,
  tradeInToken,
}: Request): Promise<ResponseBody> => {
  return api.put<ResponseBody>(`api/purchases/ico/${source}/appointment`, {
    json: {
      appointmentAt,
      dropOffLocationId,
    },
    headers: {
      authorization: `Bearer ${tradeInToken}`,
    },
  });
};

export default function useScheduleGuestBuyInAppointmentMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putScheduleGuestBuyInAppointment,
    onSuccess: (_, { tradeInToken }) => {
      queryClient.invalidateQueries({
        queryKey: tradeInQueryKeys.appraisalByToken(tradeInToken),
      });
      queryClient.invalidateQueries({ queryKey: dropOffLocationQueryKeys.all });
    },
  });
}
